module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo22-c115a010faed0e18eb5548f69eed9bf6.jpg";